export enum IconPlacement {
    Point = "Point",
    Line = "Line",
    LineCenter = "LineCenter"
}